import { render } from "./articleRight.vue?vue&type=template&id=1288b364&scoped=true"
import script from "./articleRight.vue?vue&type=script&lang=js"
export * from "./articleRight.vue?vue&type=script&lang=js"

import "./articleRight.vue?vue&type=style&index=0&id=1288b364&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1288b364"]])

export default __exports__